declare const initialModel: FormulaireNutritionModel;
declare const urlPanier: string;

function myState() {
    return {
        initialized: false,
        model: initialModel,
        step: 0,
        modeDetaille: false,
        saving: false,
        messageDureeMinutesTropCourt: false,
        dejaAjoutAuPanier: false,
        idPropositionRepasSelected: {} as Record<TypeRepas, string>,
        propositionRepasSelected: {} as Record<TypeRepas, PropositionRepas_Repas>,

        activeTypeRepas: TypeRepas.PetitDejeuner,
        activeJourAvantCourse: TypeJourAvantCourse.JMoins3 as TypeJourAvantCourse,

        propositionAliments: {} as Record<string, AlimentProposee>,
        propositionsEncas: [],
        propositionsRepas: [] as PropositionRepas[],
        searchTermIngredient: "",
        alreadySearchedTermIngredient: "",

        resultCalcul: null as CalculateurResultat | null,
        repasSelected: null as FormulaireNutrition_RepasModel | null,
        showPourquoiCesQuestions: false,

        infoStep1Lues: !!initialModel.Poids,
        infoStep2Lues: !!initialModel.Repas.length,
        infoStep3Lues: !!initialModel.DateCourse,
        introStep2Developpee: false,

        exclusionsNiveau1: [false, false, false, false, false] as boolean[],
        exclusionNiveau2: false,
        declarationPositive: false,

        step0Label: "Infos",
        step1Label: "Habitude alimentaires",
        step2Label: "Infos d'avant course",
        step3Label: "Récapitulatif",
        step4Label: "Demander le plan",

        habitudeAlimentaire_Step1: "Petit déjeuner",
        habitudeAlimentaire_Step2: "Déjeuner",
        habitudeAlimentaire_Step3: "Diner",
        habitudeAlimentaire_Step4: "Encas",

        handleTimeMask(event: any, callback: (value: string) => void) {
            const input = event.target;
            const hasColon = input.value.includes(':');
            const raw = input.value.replace(/\D/g, '');

            let h = raw.substring(0, 2);
            let m = raw.substring(2, 4);

            const rawHLen = Math.min(raw.length, 2);

            // Heures : auto-pad si premier chiffre > 2 ou ":" tapé manuellement, clamp 00-23
            if (h.length === 1 && (parseInt(h) > 2 || hasColon)) h = '0' + h;
            if (h.length === 2 && parseInt(h) > 23) h = '23';

            // Minutes : auto-pad si premier chiffre > 5, clamp 00-59
            if (m.length === 1 && parseInt(m) > 5) m = '0' + m;
            if (m.length === 2 && parseInt(m) > 59) m = '59';

            const hourPadded = h.length > rawHLen;
            const showSep = raw.length > 2 || hourPadded || (hasColon && h.length > 0);

            let result = h;
            if (showSep) result += ':' + m;

            input.value = result;
            // Lorsque l'horaire est complet, on sauvegarde le total des minutes
            if (result.length == 5) {
                callback(result)
            }
        },

        handleDateMask(event: any, callback: (value: string) => void) {
            const input = event.target;
            const digits = input.value.replace(/\D/g, '');
            let result = '';
            if (digits.length > 0) result += digits.substring(0, 2);
            if (digits.length > 2) result += '/' + digits.substring(2, 4);
            if (digits.length > 4) result += '/' + digits.substring(4, 8);
            input.value = result;
            callback(result)
        },

        nombreJours() {
            return this.model.Protocole === TypeProtocole.DeuxJours ? 2 : 3;
        },

        antecedentMedicauxValides() {
            return !(this.exclusionsNiveau1.some(e => e) || this.exclusionNiveau2 || !this.declarationPositive)
        },

        getValeurRepasAvantCourse() {
            return this.model.Poids * 2;
        },

        compositionAAjouter() {
            if (!this.activeTypeRepas || !this.idPropositionRepasSelected[this.activeTypeRepas]) return null

            if (this.propositionRepasSelected[this.activeTypeRepas]) {
                const composAAjouter = this.propositionRepasSelected[this.activeTypeRepas].PropositionAjoutCompos
                const alReadySelected = this.propositionRepasSelected[this.activeTypeRepas].Composition.map(x => x.Code)
                return composAAjouter.filter(c => alReadySelected.indexOf(c.Code) === -1)
            }
        },

        async ajouterProduitsProposesAuPanier() {
            console.log(urlPanier);
            this.model.AjouterProduitsProposesAuPanier = true;
            await this.save()
            this.dejaAjoutAuPanier = true;
            window.location.href = urlPanier;
        },

        async loadAlimentsProposes() {
            try {
                let response = await fetch(`${window.location.origin}/ciqual/getall`);
                const props = await response.json() as AlimentProposee[];

                for (const prop of props)
                    this.propositionAliments[prop.Code] = prop

            } catch (error) {
                console.error("Impossible de charger le JSON :", error);
            }
        },

        async loadRepasPropose() {
            let response = await fetch(`${window.location.origin}/Calculateur/Propositions`);
            this.propositionsRepas = await response.json();
        },

        async mounted() {
            if (!this.initialized) {
                this.initialized = true
                this.declarationPositive = this.model.AucunAntecedentMedicauxConfirme;

                await this.loadRepasPropose();
                await this.loadAlimentsProposes()
                this.preloadPropositionsRepasSelected()

                if (this.model.MailEnvoye) {
                    this.step = 5
                }
                else if (!!this.model.DateCourse) {
                    await this.loadResult()
                    this.step = 3
                } else if (this.model.Repas.some(x => x.TypeRepas == TypeRepas.PetitDejeuner) && this.model.Repas.some(x => x.TypeRepas == TypeRepas.Dejeuner) && this.model.Repas.some(x => x.TypeRepas == TypeRepas.Diner)) {
                    this.step = 2
                }
                else if (this.model.ChoixPerformance != null) {
                    this.step = 1
                }


                new MutationObserver(() => {
                    let el = document.getElementById('date-course-picker');
                    // @ts-ignore
                    if (el && !el._flatpickr) {
                        // @ts-ignore
                        flatpickr(el, {
                            dateFormat: "d/m/Y",
                            locale: "fr",
                            minDate: "today",
                            // @ts-ignore
                            onChange: (selectedDates, dateStr, instance) => {
                                instance.element.dispatchEvent(new Event('input', { bubbles: true }));
                            }
                        });
                    }
                    el = document.getElementById('heure-date-course');
                    // @ts-ignore
                    if (el && !el._flatpickr) {
                        // @ts-ignore
                        flatpickr(el, {
                            dateFormat: "H:i",
                            noCalendar: true,
                            locale: "fr",
                            enableTime: true,
                            minDate: "today",
                            // @ts-ignore
                            onChange: (selectedDates, dateStr, instance) => {
                                instance.element.dispatchEvent(new Event('input', { bubbles: true }));
                            }
                        });
                    }
                    el = document.getElementById('heure-seance-activation');
                    // @ts-ignore
                    if (el && !el._flatpickr) {
                        // @ts-ignore
                        flatpickr(el, {
                            dateFormat: "H:i",
                            noCalendar: true,
                            locale: "fr",
                            enableTime: true,
                            minDate: "today",
                            // @ts-ignore
                            onChange: (selectedDates, dateStr, instance) => {
                                instance.element.dispatchEvent(new Event('input', { bubbles: true }));
                            }
                        });
                    }
                }).observe(document.body, { childList: true, subtree: true });

                if (window.location.href.indexOf('#what-you-need') !== -1) {
                    console.log("SCROOOOLL")
                    // @ts-ignore
                    PetiteVue.nextTick(() => {
                        document.getElementById('what-you-need')?.scrollIntoView({
                            behavior: 'smooth',   // défilement animé au lieu d'un saut brut
                            block: 'start'        // 'start', 'center', 'end' ou 'nearest'
                        });
                    })

                }
            }
        },

        async navigateToStep(step: number, type?: TypeRepas | undefined) {
            const debut = performance.now();
            if (this.step == step) {
                if (this.step == 1) {
                    if (type === undefined) {
                        this.selectActiveTypeRepas(TypeRepas.PetitDejeuner)
                    } else {
                        this.selectActiveTypeRepas(type)
                    }
                }
            }
            else {
                if (step < this.step || this.validStep()) {

                    await this.save()

                    if (step == 3) {
                        await this.loadResult()
                    }

                    this.step = step;
                }

                if (step == 1) {
                    if (type === undefined) {
                        this.selectActiveTypeRepas(TypeRepas.PetitDejeuner)
                    } else {
                        this.selectActiveTypeRepas(type)
                    }
                }
            }

            const fin = performance.now();
            const duree = fin - debut;

            window.scrollTo(0, 0);
        },
        nextStep() {
            this.navigateToStep(this.step + 1)
        },
        nextStepLabel() {
            if (this.step === 0) {
                return this.step1Label
            }
            else if (this.step === 1) {
                return this.step2Label
            } else if (this.step === 2) {
                return this.step3Label
            } else if (this.step === 3) {
                return this.step4Label
            }
        },

        prevStep() {
            this.step = Math.max(this.step - 1, 0)
        },
        prevStepLabel() {
            if (this.step === 1) {
                return this.step0Label
            } else if (this.step === 2) {
                return this.step1Label
            } else if (this.step === 3) {
                return this.step2Label
            }
        },

        isStepValid(step: number): boolean {
            if (step === 0) {
                if (!this.model.Poids || this.model.Poids <= 0) {
                    return false;
                }
            }
            if (step == 1) {
                return this.model.Repas.some(x => x.TypeRepas == TypeRepas.PetitDejeuner)
                    && this.model.Repas.some(x => x.TypeRepas == TypeRepas.Dejeuner)
                    && this.model.Repas.some(x => x.TypeRepas == TypeRepas.Diner);
                // Pas obligé de sélectionner un encas
            }

            if (step == 2) {
                if (!this.model.DateCourse || !this.model.HeureDepartCourse)
                    return false;
            }

            return true;
        },
        validStep() {
            return this.isStepValid(this.step)
        },
        infosAvantCoursesValides() {
            return this.model.DateCourse && this.model.HoraireAvantCourse.length
        },
        checkDureeMinutes() {
            if (!this.model.DureeSuperieure90Minutes) {
                this.messageDureeMinutesTropCourt = true;
            } else {
                this.messageDureeMinutesTropCourt = false;
            }
        },
        isActiveTypeRepas: function (typeRepas: TypeRepas): boolean {
            return this.activeTypeRepas == typeRepas
        },

        selectInput(event: any) {
            event.target.select();
        },

        selectActiveTypeRepas(type: TypeRepas) {
            if (type === TypeRepas.Encas) {
                this.activeTypeRepas = type;
            }
            else {
                this.activeTypeRepas = type;
                this.repasSelected = null;
                const repasDejaRenseigne = this.model.Repas.find(repas => repas.TypeRepas == type)
                const propositionRepasProposes = this.propositionsRepas.find(p => p.TypeRepas == type)

                if (repasDejaRenseigne && propositionRepasProposes) {
                    const repasProposeExistant = propositionRepasProposes.Repas.find(repas => repas.Code == repasDejaRenseigne.CodeRepasPropose)

                    if (repasProposeExistant)
                        return this.selectRepas(repasProposeExistant)
                } else if (propositionRepasProposes && propositionRepasProposes.Repas.length == 1) {
                    this.selectRepas(propositionRepasProposes.Repas[0])
                }
            }
        },

        preloadPropositionsRepasSelected() {
            for (const type of [TypeRepas.PetitDejeuner, TypeRepas.Dejeuner, TypeRepas.Diner]) {
                const repasDejaRenseigne = this.model.Repas.find(repas => repas.TypeRepas == type)
                const propositionRepasProposes = this.propositionsRepas.find(p => p.TypeRepas == type)

                if (repasDejaRenseigne && propositionRepasProposes) {
                    const repasProposeExistant = propositionRepasProposes.Repas.find(repas => repas.Code == repasDejaRenseigne.CodeRepasPropose)
                    if (repasProposeExistant) {
                        this.propositionRepasSelected[type] = repasProposeExistant;
                        this.idPropositionRepasSelected[type] = repasProposeExistant.Code;
                    }
                }
            }
        },

        getRepasModel(type: TypeRepas) {
            return this.model.Repas.find(r => r.TypeRepas == type) || null
        },

        selectRepas(repas: PropositionRepas_Repas) {
            if (this.activeTypeRepas === TypeRepas.Encas) {
                // this.propositionRepasSelected[this.activeTypeRepas] = repas;
                // this.idPropositionRepasSelected[this.activeTypeRepas] = repas.Code;

                // const indexRepasExistant = this.model.Repas.findIndex(x => x.CodeRepasPropose == repas.Code)
                // if (indexRepasExistant === -1) {
                //     const repasModel = {
                //         Id: null,
                //         CodeRepasPropose: repas.Code,
                //         TypeAppetit: TypeAppetit.Moyen,
                //         Ingredients: repas.Composition.map((i) => {
                //             return {
                //                 Id: null,
                //                 CodeIngredient: i.Code.toString(),
                //                 QuantiteGrammes: i.PoidsGrammes
                //             }
                //         }),
                //         TypeRepas: this.activeTypeRepas,
                //         AjustementPersonnalise: false
                //     }

                //     this.model.Repas.push(repasModel);
                // } else {
                //     this.model.Repas.splice(indexRepasExistant, 1)
                // }
            } else {
                this.propositionRepasSelected[this.activeTypeRepas] = repas;
                this.idPropositionRepasSelected[this.activeTypeRepas] = repas.Code;
                console.log(this.propositionRepasSelected[this.activeTypeRepas], this.propositionRepasSelected[this.activeTypeRepas].Appetits)

                const indexRepasExistant = this.model.Repas.findIndex(x => x.TypeRepas == this.activeTypeRepas)
                if (indexRepasExistant != -1) {
                    if (this.model.Repas[indexRepasExistant].CodeRepasPropose == repas.Code) {
                        this.repasSelected = this.model.Repas[indexRepasExistant];
                        return;
                    } else {
                        this.model.Repas.splice(indexRepasExistant, 1)
                    }
                }

                const repasModel = {
                    Id: null,
                    CodeRepasPropose: repas.Code,
                    TypeAppetit: TypeAppetit.Moyen,
                    Ingredients: repas.Composition.map((i) => {
                        return {
                            Id: null,
                            CodeIngredient: i.Code.toString(),
                            QuantiteGrammes: i.PoidsGrammes
                        }
                    }),
                    TypeRepas: this.activeTypeRepas,
                    AjustementPersonnalise: false
                } as FormulaireNutrition_RepasModel

                this.model.Repas.push(repasModel);
                this.repasSelected = repasModel;
            }
        },

        deselectionnerRepas(type: TypeRepas) {
            const indexRepasExistant = this.model.Repas.findIndex(x => x.TypeRepas == type)
            if (indexRepasExistant !== -1) {
                this.model.Repas.splice(indexRepasExistant, 1)
            }

            delete this.propositionRepasSelected[type];
            delete this.idPropositionRepasSelected[type];

            if (this.repasSelected && this.repasSelected.TypeRepas == type) {
                this.repasSelected = null;
            }
        },

        isRepasSelected(repas: PropositionRepas_Repas): boolean {
            return this.model.Repas.some((r) => r.CodeRepasPropose == repas.Code);
        },

        getRepasSelectionneProposition(proposition: PropositionRepas): PropositionRepas_Repas | null {
            const repasModel = this.model.Repas.find(r => r.TypeRepas == proposition.TypeRepas)
            if (!repasModel) return null

            return proposition.Repas.find(r => r.Code == repasModel.CodeRepasPropose) || null
        },
        getLabelTypeRepas(type: TypeRepas) {
            switch (type) {
                case TypeRepas.Dejeuner: return "Déjeuner";
                case TypeRepas.Diner: return "Diner";
                case TypeRepas.Encas: return "Encas";
                case TypeRepas.PetitDejeuner: return "Petit déjeuner";
            }
            return ""
        },
        getTauxGlucideIngredient(repas: FormulaireNutrition_RepasModel, aliment: FormulaireNutrition_Repas_IngredientModel) {
            return this.getFacteurAppetit(repas) * this.propositionAliments[aliment.CodeIngredient].GlucidesPour100g * 0.01 * aliment.QuantiteGrammes
        },
        getTauxGlucideIngredientText(repas: FormulaireNutrition_RepasModel, aliment: FormulaireNutrition_Repas_IngredientModel) {
            return this.getTauxGlucideIngredient(repas, aliment).toFixed(0)
        },
        getFacteurAppetit(repas: FormulaireNutrition_RepasModel): number {
            switch (repas.TypeAppetit) {
                case TypeAppetit.Faible: return .5
                case TypeAppetit.Moyen: return 1
                case TypeAppetit.Fort: return 1.5
            }
            return 1
        },
        printIngredients(repas: PropositionRepas_Repas) {
            const print = repas.Composition
                .map(i => {
                    const ingredient = this.propositionAliments[i.Code.toString()]
                    if (!ingredient)
                        return null
                    return {
                        nom: ingredient.Nom,
                        quantite: i.PoidsGrammes
                    }
                })
                .filter(x => x != null)
                .reduce((prev, current) => `${prev}${current.nom} (${current.quantite}g), `, '')

            return print.substring(0, print.length - 2)
        },

        searchedIngredient() {
            const debut = performance.now();
            if (this.alreadySearchedTermIngredient == this.searchTermIngredient)
                return;

            this.alreadySearchedTermIngredient = this.searchTermIngredient

            const listeIngredients = [] as { score: number, aliment: AlimentProposee }[]
            if (this.searchTermIngredient.length < 3)
                return []
            const limiteIngredients = 10
            const terms = this.searchTermIngredient.toLowerCase().split(' ')

            for (const ingredientProposeIndex in this.propositionAliments) {
                const ingredientPropose = this.propositionAliments[ingredientProposeIndex];
                const ingredientLabel = ingredientPropose.Nom.toLowerCase()
                let score = 0;
                for (const term of terms) {
                    if (ingredientLabel.indexOf(term) !== -1) {
                        score++;
                    }
                }

                if (score > 0) {
                    listeIngredients.push({ score: score, aliment: ingredientPropose })
                }
            }

            const res = listeIngredients
                .sort(((prop1, prop2) => prop2.score - prop1.score))
                .slice(0, limiteIngredients)
                .map(x => x.aliment)

            return res;
        },

        percentageProgressionRepas() {
            const valueGrammes = this.totalGlucidesRepas()
            return valueGrammes * 100.0 / this.totalGlucideACouvrir()
        },
        widthProgressionRepas() {
            const valueGrammes = this.totalGlucidesRepas()
            return `width: ${this.percentageProgressionRepas().toFixed(0)}%`;
        },
        percentageProgressionAmont() {
            const totalAmontEnGrammes = this.totalAmont()
            const percentage = totalAmontEnGrammes * 100.0 / this.totalGlucideACouvrir();
            return percentage;
        },
        widthProgressionAmont() {
            return `width: ${this.percentageProgressionAmont().toFixed(0)}%`;
        },
        percentageProgressionEmpty() {
            return 100 - this.percentageProgressionAmont() - this.percentageProgressionRepas();
        },
        widthProgressionEmpty() {
            return `width: ${(this.percentageProgressionEmpty()).toFixed()}%`;
        },
        totalAmont() {
            const valueGrammes = this.totalGlucidesRepas();
            const max = this.totalGlucideACouvrir();

            const valeur = max - valueGrammes < 200 ?
                max - valueGrammes :
                200;

            return valeur;
        },
        totalEmpty() {
            return this.totalGlucideACouvrir() - this.totalAmont() - this.totalGlucidesRepas()
        },
        totalGlucideACouvrir() {
            return this.model.Poids * this.model.GrammesSurcharge
        },
        totalGlucidesRepas() {
            return this.model.Repas
                .map(repas => repas.Ingredients
                    .map(ingredient => this.getTauxGlucideIngredient(repas, ingredient))
                    .reduce((prev, current) => prev + current, 0))
                .reduce((prev, glucideParRepas) => prev + glucideParRepas, 0)
        },
        getQuantiteEncas(repas: PropositionRepas_Repas) {
            return this.model.Repas.filter(x => x.CodeRepasPropose == repas.Code).length
        },
        decrementEncas(repas: PropositionRepas_Repas) {
            this.propositionRepasSelected[this.activeTypeRepas] = repas;
            this.idPropositionRepasSelected[this.activeTypeRepas] = repas.Code;

            const indexRepasExistant = this.model.Repas.findIndex(x => x.CodeRepasPropose == repas.Code)
            if (indexRepasExistant !== -1) {
                this.model.Repas.splice(indexRepasExistant, 1)
            }
        },
        incrementEncas(repas: PropositionRepas_Repas) {
            this.propositionRepasSelected[this.activeTypeRepas] = repas;
            this.idPropositionRepasSelected[this.activeTypeRepas] = repas.Code;

            const repasModel = {
                Id: null,
                CodeRepasPropose: repas.Code,
                TypeAppetit: TypeAppetit.Moyen,
                Ingredients: repas.Composition.map((i) => {
                    return {
                        Id: null,
                        CodeIngredient: i.Code.toString(),
                        QuantiteGrammes: i.PoidsGrammes
                    }
                }),
                TypeRepas: this.activeTypeRepas,
                AjustementPersonnalise: false
            }

            this.model.Repas.push(repasModel);
        },
        typesAppetits(type: TypeRepas) {
            if (!this.propositionRepasSelected[type]) {
                return []
            }

            return [
                { name: "Petit appétit", value: TypeAppetit.Faible, img: this.propositionRepasSelected[type].Img.replace("medium", "small") },
                { name: "Appétit normal", value: TypeAppetit.Moyen, img: this.propositionRepasSelected[type].Img },
                { name: "Grand appétit", value: TypeAppetit.Fort, img: this.propositionRepasSelected[type].Img.replace("medium", "large") }
            ]
        },
        getSizeFriseResultCalcul(value: number) {
            if (this.resultCalcul)
                return 'width:' + value / this.resultCalcul.Cible * 100 + '%'

            return 0
        },

        typesSports: [
            { name: "Course à pied", value: TypeSport.CourseAPied },
            { name: "Vélo", value: TypeSport.Velo },
            { name: "Triathlon", value: TypeSport.Triathlon }
        ],

        typesProtocoles: [
            { name: "2 jours", value: TypeProtocole.DeuxJours },
            { name: "3 jours", value: TypeProtocole.TroisJours }
        ],
        async save() {
            this.saving = true
            // @ts-ignore
            const token = document.querySelector('input[name="__RequestVerificationToken"]').value;
            const response = await fetch('/calculateur/post', {
                method: 'POST',
                headers: {
                    "Content-Type": "application/json",
                    "RequestVerificationToken": token
                },
                body: JSON.stringify(this.model)
            })
            if (response.ok)
                this.model = await response.json();

            this.saving = false
        },
        async saveAndAskForPlan() {

            if (this.step == 4) {
                this.model.EndFormulaire = true
            }

            await this.save();

            this.nextStep()
        },
        async loadResult() {// @ts-ignore
            const token = document.querySelector('input[name="__RequestVerificationToken"]').value;

            let response = await fetch(`/calculateur/Calculate/${this.model.Id}`, {
                method: 'GET',
                headers: {
                    "Content-Type": "application/json",
                    "RequestVerificationToken": token
                }
            });

            const res = await response.json()

            this.resultCalcul = res;
        },
        getPrisesAmontParJour() {
            if (this.resultCalcul) {
                var res = [] as { [key: number]: PrisePoudreAmont[] }
                for (const prise of this.resultCalcul.PrisesAmont) {
                    if (!res[prise.Jour]) {
                        res[prise.Jour] = []
                    }
                    if (prise.Grammes)
                        res[prise.Jour].push(prise)
                }
                return res;
            }

            return []
        },
        canAskPlan(requiredMail: boolean) {
            return (!requiredMail || !!this.model.Email) && this.model.PlanNiveauPrecision !== null && this.antecedentMedicauxValides() && this.model.CgvCguAcceptees
        },

        phraseJoursDeCharge(): string {
            const nombreJours = this.model.Protocole === TypeProtocole.TroisJours ? 3 : 2

            if (!this.model.DateCourse) return `${nombreJours} jours`

            const [jour, mois, annee] = this.model.DateCourse.split('/').map(Number)
            const dateCourse = new Date(annee, mois - 1, jour)

            const joursSemaine = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi']
            const nomsMois = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre']

            const dates: Date[] = []
            for (let i = nombreJours; i >= 1; i--) {
                const d = new Date(dateCourse)
                d.setDate(d.getDate() - i)
                dates.push(d)
            }

            const memeMois = dates.every(d => d.getMonth() === dates[0].getMonth() && d.getFullYear() === dates[0].getFullYear())

            const labels = dates.map((d, i) => {
                const jourLabel = `${joursSemaine[d.getDay()]} ${d.getDate()}`
                return (!memeMois || i === dates.length - 1) ? `${jourLabel} ${nomsMois[d.getMonth()]}` : jourLabel
            })

            const liste = labels.length === 1
                ? labels[0]
                : labels.slice(0, -1).join(', ') + ' et ' + labels[labels.length - 1]

            return `${nombreJours} jours, ${liste}`
        }

    };
}
